import { all, put, takeLatest } from 'redux-saga/effects';
import store from '../../../../../store/store';

import MasterService from '../../../../../services/MasterService';
import { componentKey, setMasterMedicationList } from './MasterMedicationSlice';
import { addNotifications } from '../../../../../components/common-components/toaster/ToasterSlice';
import { TOASTER_VARIANT } from '../../../../../components/common-components/toaster/MetToaster';

export const { getMasterMedication, createMasterMedication, updateMasterMedication, deleteMasterMedication, bulkUploadMasterMedication} = {
    getMasterMedication: (payload) => {
        return {
            type: 'MASTER_MEDICATION/GET_MASTER_MEDICATION_LIST',
            payload,
        };
    },
    createMasterMedication: (payload) => {
        return {
            type: 'MASTER_MEDICATION/CREATE_MASTER_MEDICATION',
            payload,
        };
    },
    updateMasterMedication: (payload) => {
        return {
            type: 'MASTER_MEDICATION/UPDATE_MASTER_MEDICATION_LIST',
            payload,
        };
    },
    deleteMasterMedication: (payload) => {
        return {
            type: 'MASTER_MEDICATION/DELETE_MASTER_MEDICATION_LIST',
            payload,    
        };    
    },
    bulkUploadMasterMedication: (payload) => {
        return {
            type: 'MASTER_MEDICATION/BULK_UPLOAD_MASTER_MEDICATION',
            payload,
        };
    }
};

function* getMasterMedicationAsync(action) {
    try {
        const response = yield MasterService.getMasterMedicationList(action.payload);
        const {  status } = response.data; 
        if (status) {
            yield put(setMasterMedicationList(response.data));
        }
    } catch (error) {
        console.log('error', error);
        yield put(setMasterMedicationList([]));

    }
}

function* createMasterMedicationAsync(action) {
    try {
        const response = yield MasterService.createMasterMedication(action.payload?.apiPayload);
        const {  status, message } = response.data;
        
        if (status) {
            yield put(addNotifications({ message: message || "Medication created successfully", variant: TOASTER_VARIANT.SUCCESS }))
            action.payload?.closeEditModal();
            yield put(getMasterMedication());
        }
    } catch (error) {
        yield put(addNotifications({ message: error?.data?.message || "Failed to create medication", variant: TOASTER_VARIANT.ERROR }))
        console.log('error', error);
    }
}

function* updateMasterMedicationAsync(action) {
    try {
        const response = yield MasterService.updateMasterMedication(action.payload?.id, action.payload?.apiPayload);
        const {  status, message } = response.data;
        
        if (status) {
            yield put(addNotifications({ message: message, variant: TOASTER_VARIANT.SUCCESS }))
            action.payload?.closeEditModal();
            yield put(getMasterMedication());
        }
    } catch (error) {
        yield put(addNotifications({ message: error?.data?.message || "Something went wrong", variant: TOASTER_VARIANT.ERROR }))
        console.log('error', error);
    }
}

function* bulkUploadMasterMedicationAsync(action) {
    try {
        const response = yield MasterService.bulkUploadMasterMedication(action.payload?.fileData);
        const {  status, message, validationErrors } = response.data;
        
        if (status) {
            yield put(addNotifications({ message: message || "Bulk upload completed successfully", variant: TOASTER_VARIANT.SUCCESS }))
            action.payload?.closeEditModal();
            yield put(getMasterMedication());
        } else if (validationErrors) {
            // Handle validation errors from API
            const errorMessage = Array.isArray(validationErrors) 
                ? validationErrors.join(', ') 
                : validationErrors;
            yield put(addNotifications({ message: errorMessage, variant: TOASTER_VARIANT.ERROR }))
        }
    } catch (error) {
        yield put(addNotifications({ message: error?.response?.data?.message || "Bulk upload failed", variant: TOASTER_VARIANT.ERROR }))
        console.log('error', error);
    }
}

function* deleteMasterMedicationAsync(action) {
    try {
        const response = yield MasterService.deleteMasterMedication(action.payload?.id);
        const {  status, message } = response.data;
        
        if (status) {
            yield put(addNotifications({ message: message, variant: TOASTER_VARIANT.SUCCESS }))
            action.payload?.setOpenDeleteModal();
            yield put(getMasterMedication());
        }
    } catch (error) {
        yield put(addNotifications({ message: error?.data?.message || "Something went wrong", variant: TOASTER_VARIANT.ERROR }))
        console.log('error', error);
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getMasterMedication().type, getMasterMedicationAsync), 
        takeLatest(createMasterMedication().type, createMasterMedicationAsync),
        takeLatest(updateMasterMedication().type, updateMasterMedicationAsync) ,
        takeLatest(deleteMasterMedication().type, deleteMasterMedicationAsync),
        takeLatest(bulkUploadMasterMedication().type, bulkUploadMasterMedicationAsync)     
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);
